import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Agitation } from './components/Agitation';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { Differentiator } from './components/Differentiator';
import { Benefits } from './components/Benefits';
import { WhoItsFor } from './components/WhoItsFor';
import { Disclaimer } from './components/Disclaimer';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-bg-primary font-sans text-white selection:bg-cyan/30 selection:text-cyan" data-id="element-0">
      {/* Global Background Elements */}
      <div className="bg-grid" data-id="element-1" />
      <div className="scan-lines" data-id="element-2" />
      <div className="bg-glow-top" data-id="element-3" />

      {/* Floating Particles */}
      <div className="particle w-1.5 h-1.5 top-[20%] left-[15%] animate-[float-1_8s_infinite_ease-in-out]" data-id="element-4" />
      <div className="particle w-2 h-2 top-[60%] left-[80%] animate-[float-2_12s_infinite_ease-in-out]" data-id="element-5" />
      <div className="particle w-1 h-1 top-[80%] left-[25%] animate-[float-3_10s_infinite_ease-in-out]" data-id="element-6" />
      <div className="particle w-1.5 h-1.5 top-[30%] left-[75%] animate-[float-1_15s_infinite_ease-in-out_reverse]" data-id="element-7" />

      <Navbar data-id="element-8" />

      <main data-id="element-9">
        <Hero data-id="element-10" />
        <Problem data-id="element-11" />
        <Agitation data-id="element-12" />
        <Solution data-id="element-13" />
        <HowItWorks data-id="element-14" />
        <Differentiator data-id="element-15" />
        <Benefits data-id="element-16" />
        <WhoItsFor data-id="element-17" />
        <Disclaimer data-id="element-18" />
        <ClosingCTA data-id="element-19" />
      </main>

      <Footer data-id="element-20" />
    </div>;
}